import { Components } from "@mdx-js/react";
import {
  a,
  blockquote,
  code,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  hr,
  iframe,
  img,
  inlineCode,
  li,
  ol,
  p,
  pre,
  table,
  tbody,
  td,
  th,
  thead,
  tr,
  ul,
} from "./Elements";

const MDXComponents: Components = {
  a,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  hr,
  img,
  inlineCode,
  code,
  blockquote,
  pre,
  table,
  th,
  td,
  tbody,
  thead,
  tr,
  ul,
  ol,
  li,
  iframe,
};

export default MDXComponents;
